import packageJson from '../../package.json';

/** App version baked into the JS bundle at build time (what's actually running). */
export const APP_VERSION = packageJson.version;

export default APP_VERSION;
